module.exports = __webpack_public_path__ + "fonts/sourcesansproextralight.a0063366.woff";